import React, { Component } from "react";
import { LocalStorageService, WorkflowService, NegotiationCntractService, RevisionClientContractService } from "../../../services";
import { ConsultNegotationView } from "../../views";
import { getNavigatorTimezone } from "../../../utils";
import { useTranslation, withTranslation } from "react-i18next";

class ConsultNegotationAction extends Component {
    constructor(props){
        super(props)
        this.state = {
            isLoadingView: false,
            token: '',
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
            headerTitle: this.props.t("consultNegotiation.header.title"),
            showNegotiators: true,
            showGuests: true,
            showChages: true,
            negotiators: [],
            guests: [],
            changes: [],
            url: '',
            isOriginalPDF: false,
            originalPDF: '',
            updatePDF:'',
            labelBtnPDF: this.props.t("consultNegotiation.original.btn")
        }
    }

    token = {}
    user = {}
    solicitudeId = ''
    workflowExecutionId = ''
    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService ()
    workflowService = new WorkflowService(this.url);
    negotiationCntractService = new NegotiationCntractService(this.url)
    revisionClientContractService = new RevisionClientContractService(process.env.REACT_APP_MIFIRMA_API);
    timezone = getNavigatorTimezone()

    async componentDidMount(){
        this.toggleLoadingView(true)
        this.token = this.localStorageService.getLocalStorageItem("token").idToken;
        this.user = this.localStorageService.getLocalStorageItem("user");
        let urlArr = window.location.href.split('/')
        this.solicitudeId = Number(urlArr[urlArr.length - 2])
        this.workflowExecutionId = urlArr[urlArr.length - 1]

        this.getTeamNegotiation()
        this.getChangesContract()
    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoadingView: value
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showErrorRequesting: true,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo)
                    }
                }
            }, time || 4000)
        })
    }

    toggleCompletedRequesting = (time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showCompletedRequesting: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo);
                    }
                }
            }, time || 4000)
        })
    }

    getTeamNegotiation = async() => {
        let messageError = this.props.t("consultNegotiation.errors.getnegotiation")
        try {
            let teamNegotiation = await this.negotiationCntractService.getTeamNegotiationAndContract(this.workflowExecutionId, this.token)
            if(teamNegotiation && teamNegotiation.data && Number(teamNegotiation.statusCode) === 200){
                let ownTeam = (teamNegotiation && teamNegotiation.data.ownTeam) ? teamNegotiation.data.ownTeam : []
                let guests = (teamNegotiation && teamNegotiation.data.guests) ? teamNegotiation.data.guests : []
                let url = (teamNegotiation && teamNegotiation.data.clientContract.updatedDocumentPathPdf) ? teamNegotiation.data.clientContract.updatedDocumentPathPdf : ''
                let originalPDF = (teamNegotiation && teamNegotiation.data.clientContract.originalDocumentPathPdf) ? teamNegotiation.data.clientContract.originalDocumentPathPdf : ''
                
                this.setState({
                    negotiators: ownTeam,
                    guests,
                    url,
                    updatePDF: url,
                    originalPDF,
                })

            }else{
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, true, '/')
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, '/')
        }
    }

    getChangesContract = async () => {
        let messageError = this.props.t("consultNegotiation.errors.getContract")

        try {
            let changesContract =await this.revisionClientContractService.getRevisionContract(this.workflowExecutionId, this.timezone, this.token);
            if (changesContract && changesContract.data && Number(changesContract.statusCode) === 200) {
                let changes = changesContract.data.map((change) => {
                    switch (change.changeAccepted) {
                        case "pending":
                        change.status = this.props.t("consultNegotiation.status.contract.proposed")
                        break;
                        case "accepted":
                        change.status = this.props.t("consultNegotiation.status.contract.accepted")
                        break;
                        case "rejected":
                        change.status = this.props.t("consultNegotiation.status.contract.rejected")
                        break;
                        default:
                        change.status = this.props.t("consultNegotiation.status.contract.proposed")
                        break;
                    }

                    switch (change.type) {
                        case "Insertion":
                        change.action = this.props.t("consultNegotiation.type.contract.add")
                        break;
                        case "Deletion":
                        change.action = this.props.t("consultNegotiation.type.contract.deleted")
                        break;
                        default:
                        change.action = this.props.t("consultNegotiation.type.contract.add")
                        break;
                    }
                    return change
                })

                this.setState({
                changes
                });

                this.toggleLoadingView(false)
            } else {
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, true, '/')
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, '/')
        }
    };

    changeUrlPDF = () => {
        let urlUpdated = (this.state.isOriginalPDF) ?  this.state.updatePDF : this.state.originalPDF
        let labelBtnUpdated = (this.state.isOriginalPDF) ?  this.props.t("consultNegotiation.original.btn") : this.props.t("consultNegotiation.current.btn")

        this.setState({
            url: urlUpdated,
            isOriginalPDF: !this.state.isOriginalPDF,
            labelBtnPDF: labelBtnUpdated
        })
    }

    render(){
        return(
            <ConsultNegotationView
                {...this.state}
                {...this.props}

                changeUrlPDF={this.changeUrlPDF}
            />
        )
    }
}

function ConsultNegotationActionContainer(props){
    const { t } = useTranslation();

    return (
        <ConsultNegotationAction 
            {...props}
            t={t}
        />
    )
}

export default withTranslation()(ConsultNegotationActionContainer);
